import React, { useState, useCallback, useEffect, useRef } from 'react';
import { roles } from '../../Constants';
import useApi from '../../api/useApi';

function CreateFence({ handleClose, action, geofenceId, refreshList, notification }) {
  const orgId = JSON.parse(sessionStorage.user).organization.id;
  const { userId } = JSON.parse(sessionStorage.user).user;
  const formModel = {
    name: '',
    radius: null,
    longitude: null,
    latitude: null,
    level: '',
    isActive: true,
    levelId: orgId,
    organizationId: orgId,
    createdBy: userId,
    recipients: null,
    status: action === 'create' ? 'Active' : '',
  };

  const [formData, setFormData] = useState(formModel);
  const [{ isLoading, isError, data }, postData] = useApi();
  const [state, getDataForUpdate] = useApi();
  const [project, setProject] = useApi();
  const [device, setDevice] = useApi();
  const [attributes, setAttributes] = useState([]);
  const [deviceTypeRes, getDeviceType] = useApi();

  const sms = useRef(null);
  const handleInputChange = useCallback((e) => setFormData({ ...formData, [e.target.name]: e.target.value }));

  useEffect(() => {
    setProject(`/organization/${orgId}/projects`, 'GET');
  }, []);

  useEffect(() => {
    if (formData.level === 'BLE_GW' || formData.level === 'CATM1_TAG')
      setDevice(`/organization/${orgId}/devices?deviceType=${formData.level}`, 'GET');
  }, [formData.level]);

  useEffect(() => {
    if (action === 'update') {
      getDataForUpdate(`/geofence/${geofenceId}`, 'GET');
    }
  }, [action]);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (formData.status === 'InActive') {
      formData.isActive = false;
    } else {
      formData.isActive = true;
    }
    if (sms.current.value) {
      attributes.push(sms.current.value);
    }
    formData.recipients = attributes.length > 0 ? attributes : null;
    const body = {
      ...formData,
      radius: parseFloat(formData.radius),
      longitude: parseFloat(formData.longitude),
      latitude: parseFloat(formData.latitude),
      level: formData.level === 'BLE_GW' || formData.level === 'CATM1_TAG' ? 'DEVICE' : formData.level,
    };
    if (action === 'create') postData('/geofence', 'POST', body);
    else postData(`/geofence/${geofenceId}`, 'PATCH', body);
  };

  useEffect(() => {
    if (!isLoading && !isError && data) {
      refreshList();
      if (action === 'create') notification('success', 'GeoFence Created Successfully');
      else notification('update', 'GeoFence Updated Successfully');
      handleClose();
    }
  }, [isLoading, isError, data]);

  useEffect(() => {
    if (!state.isLoading && !state.isError && state.data) {
      if (state.data.geofence.isActive) {
        formData.status = 'Active';
      } else {
        formData.status = 'InActive';
      }
      setFormData(state.data.geofence);

      if (state.data.geofence.level === 'DEVICE') getDeviceType(`/device/${state.data.geofence.levelId}`, 'GET');

      if (state.data.geofence.recipients) setAttributes(state.data.geofence.recipients);
    }
  }, [state]);

  useEffect(() => {
    if (!deviceTypeRes.isLoading && !deviceTypeRes.isError && deviceTypeRes.data) {
      // if(deviceTypeRes.data.deviceType === "CATM1_TAG"){
      setFormData({ ...formData, level: deviceTypeRes.data.device.deviceType });
      // }
    }
  }, [deviceTypeRes]);

  function ValidateEmail(mail) {
    if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(mail)) {
      return true;
    }
    return false;
  }

  const handleAddAttributes = (e) => {
    e.preventDefault();
    const k = sms.current.value;
    if (!ValidateEmail(k)) {
      notification('error', `Enter valid emailId`);
      sms.current.value = '';
      return;
    }
    const x = attributes;
    setAttributes([...x, k]);
    sms.current.value = '';
  };

  const deleteAttribute = (item) => {
    const filterAttributes = attributes.filter((x) => x !== item);

    setAttributes(filterAttributes);
  };

  return (
    <div
      className="flex justify-center items-center h-full w-full fixed z-50"
      style={{ background: 'linear-gradient(rgba(0, 0, 0, 0.5),   rgba(0, 0, 0, 0.5))' }}
    >
      <div className="bg-white w-2/4 pt-1 relative rounded-2xl mobile_toggle">
        <div className="py-4 px-6 border-b flex justify-between items-center">
          <p className="font-bold text-sm text-textBlue1">{action === 'create' ? 'Create' : 'Edit'} a GeoFence</p>
          <img src="assets/img/Close.svg" className="h-3 cursor-pointer" alt="" onClick={handleClose} />
        </div>
        <form className="mt-6 mb-2 mx-10 flex flex-wrap" onSubmit={handleSubmit} autoComplete="off">
          <div className="mt-5 w-2.25/5 relative">
            <input
              type="text"
              placeHolder="Name"
              value={formData.name}
              name="name"
              autoComplete="off"
              className="inputLabelText px-4 py-2 focus:outline-none"
              onChange={handleInputChange}
            />
          </div>
          <div className="w-1/10" />
          <div className="mt-5 w-2.25/5 relative">
            <input
              type="text"
              placeHolder="Radius"
              value={formData.radius}
              name="radius"
              autoComplete="off"
              className="inputLabelText px-4 py-2 focus:outline-none"
              onChange={handleInputChange}
            />
          </div>
          <div className="mt-5 w-2.25/5 relative">
            <input
              type="text"
              placeHolder="Latitude"
              value={formData.latitude}
              name="latitude"
              autoComplete="off"
              className="inputLabelText px-4 py-2 focus:outline-none"
              onChange={handleInputChange}
            />
          </div>
          <div className="w-1/10" />
          <div className="mt-5 w-2.25/5 relative">
            <input
              type="text"
              placeHolder="Longitude"
              value={formData.longitude}
              name="longitude"
              autoComplete="off"
              className="inputLabelText px-4 py-2 focus:outline-none"
              onChange={handleInputChange}
            />
          </div>
          <div className="mt-5 w-2.25/5 relative">
            <div className="px-4 py-2 focus:outline-none inputLabelText">
              <select
                name="level"
                value={formData.level}
                autoComplete="off"
                className="border-none w-full focus:outline-none text-sm  text-parameter border "
                onChange={handleInputChange}
              >
                <option className="fy-4">Select Scope</option>
                <option key="organization" value="ORGANIZATION">
                  Organization
                </option>
                {/* <option key="device" value="DEVICE">
                  Device
                </option> */}
                {/* <option key="project" value="PROJECT">
                  Project
                </option> */}
                <option value="CATM1_TAG">Cellular Tag</option>
                <option value="BLE_GW">BLE Gateway</option>
              </select>
            </div>
          </div>
          <div className="w-1/10" />
          {formData.level && formData.level !== 'ORGANIZATION' && (
            <div className="mt-5 w-2.25/5 relative">
              <div className="px-4 py-2 focus:outline-none inputLabelText">
                {/* {formData.level === 'ORGANIZATION' && (
                  <input
                    name="levelId"
                    type="text"
                    autoComplete="off"
                    className="bg-white"
                    onChange={handleInputChange}
                    disabled
                  />
                )} */}
                {(formData.level === 'BLE_GW' || formData.level === 'CATM1_TAG') && (
                  <select
                    name="levelId"
                    value={formData.levelId}
                    autoComplete="off"
                    className="border-none w-full focus:outline-none text-sm  text-parameter border "
                    onChange={handleInputChange}
                  >
                    <option className="fy-4">Select Device</option>
                    {device.data &&
                      device.data.devices &&
                      device.data.devices.map((x) => (
                        <option key={x.id} value={x.id} className="fy-4">
                          {x.id}
                        </option>
                      ))}
                  </select>
                )}
                {formData.level === 'PROJECT' && (
                  <select
                    name="levelId"
                    value={formData.levelId}
                    autoComplete="off"
                    className="border-none w-full focus:outline-none text-sm  text-parameter border "
                    onChange={handleInputChange}
                  >
                    <option className="fy-4">Select Project</option>
                    {project.data &&
                      project.data.projects.map((x) => (
                        <option key={x.id} value={x.id} className="fy-4">
                          {x.projectName}
                        </option>
                      ))}
                  </select>
                )}
              </div>
            </div>
          )}

          <div className="mt-5 w-2.25/5 relative">
            <div className="inputLabelText px-4 py-2 focus:outline-none">
              <select
                name="status"
                value={formData.status}
                autoComplete="off"
                className="border-none w-full focus:outline-none text-sm  text-parameter border "
                onChange={handleInputChange}
              >
                <option key="true" value="Active" className="fy-4">
                  ACTIVE
                </option>
                <option key="false" value="InActive" className="fy-4">
                  INACTIVE
                </option>
              </select>
            </div>
          </div>
          {(formData.level === 'PROJECT' || formData.level === 'BLE_GW' || formData.level === 'CATM1_TAG') && (
            <div className="w-1/10" />
          )}
          {/* <div className="w-2.25/5 mt-5 mb-2" />
          <div className="w-2.25/5 mt-5 mb-2" /> */}
          <div className="mt-4 w-2.25/5 relative">
            <input
              type="email"
              placeholder="Email of Receipient"
              ref={sms}
              autoComplete="off"
              className="inputLabelText px-4 py-2 focus:outline-none"
              // style={{ color: '#b3b3b3' }}
              onChange={handleInputChange}
              onKeyDown={(e) => {
                // e.preventDefault()
                if (e.keyCode === 13) {
                  handleAddAttributes(e);
                }
              }}
            />
          </div>
          <div className="w-full flex mt-4 text-center">
            {attributes &&
              attributes.map((item) => (
                <p
                  className="text-black text-xs py-1.5 px-4 text-center rounded-full border mr-4 shadow-md cursor-pointer"
                  onClick={() => deleteAttribute(item)}
                >
                  {item}
                </p>
              ))}
          </div>
          <div className="w-full mt-5 mb-2 relative">
            {/* {'state2.isLoading || isLoading' ? (
              <div className="flex text-xs">
                <img src="assets/img/loader.svg" className="w-16 right-28 mx-auto" alt="" />
              </div>
            ) : ( */}
            <div className="flex text-xs w-full justify-end">
              <button
                type="submit"
                onClick={() => handleClose()}
                className="rounded-3xl ml-auto border focus:outline-none w-1/5 py-2.5 mr-3 cursor-pointer "
                // style={{ border: '1px solid #16406D' }}
              >
                Cancel
              </button>
              <button
                type="submit"
                className="rounded-3xl focus:outline-none w-1/5 py-2.5 text-white cursor-pointer "
                style={{ background: '#16406D' }}
              >
                Save
              </button>
            </div>
            {/* )} */}
          </div>
        </form>
      </div>
    </div>
  );
}

export default CreateFence;
